import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=82a4bf1c&scoped=true"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=82a4bf1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4bf1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a4bf1c')) {
      api.createRecord('82a4bf1c', component.options)
    } else {
      api.reload('82a4bf1c', component.options)
    }
    module.hot.accept("./AddUserModal.vue?vue&type=template&id=82a4bf1c&scoped=true", function () {
      api.rerender('82a4bf1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/Modal/AddUserModal.vue"
export default component.exports